// entry point for webpack, can import js here, also creates css files

import "./scss/_to-top.scss";

jQuery(document).ready(function($) {

	// Smooth Scroll
	$("#to-top").click(function () {

    //1 second of animation time
    //html works for FFX but not Chrome
    //body works for Chrome but not FFX
    //This strange selector seems to work universally

    $("html, body").animate({scrollTop: 0}, 600);
  });

  // only show button after treshold
  var lastScrollFromTop = 500;
  var bottomOffset = 100;
  
  $(window).on('load scroll', function() {
  
    var scrollTop = $(this).scrollTop();
    var scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();
    
    if ( scrollTop > lastScrollFromTop ) {  
      $('.acf-block-to-top__link').addClass('is-visible');
    } else {  
      $('.acf-block-to-top__link').removeClass('is-visible');
    }

    if ( scrollBottom < bottomOffset ) {  
      $('.acf-block-to-top__link').addClass('is-bottom');
    } else {  
      $('.acf-block-to-top__link').removeClass('is-bottom');
    }
  
  });

});

